// Reopen Shopify's existing native preferences dialog without changing consent.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-corporate-cookie-preferences]');
  if (!button) return;
  try {
    if (!window.privacyBanner) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    await window.privacyBanner.showPreferences();
  } catch (error) {
    console.error('Unable to open Shopify cookie preferences', error);
  }
});
